import Layout from "../include/layout";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Button, Container, Form, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import ClassesService from "../classe/ClassesService";
import $ from 'jquery'
import StatutsService from "../statuts/StatutsService";
import Filarial from "../include/filarial";
import Joi from "joi-browser";
import DevoirsService from "./DevoirsService";
import TypesevaluationsService from "../typesevaluations/TypesevaluationsService";
import dayjs from "dayjs";


export default function DevoirsEdit() {
    const token = useSelector(state => state.auth.token)
    const activeLink = "Devoirs"
    const [devoirs, setDevoirs] = useState([]);

    const [statuts, setStatuts] = useState([])
    //End
    const [errors, setErrors] = useState({});

    const navigate = useNavigate()
    const location = useLocation()

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)


    const [rowData, setRowData] = useState([{
        id: "",
        libelleDevoir: "",
        typeevaluationId: "",
        descriptionDevoir: "",
        dateDevoir: "",
        heuredebutDevoir: "",
        heurefinDevoir: "",
    }]);
    const [typesevaluations, setTypesevaluations] = useState([]);
    const [validationError, setValidationError] = useState({});
    const [libelleDevoir, setlibelleDevoir] = useState('');
    const [descriptionDevoir, setdescriptionDevoir] = useState('');
    const [dateDevoir, setdateDevoir] = useState('');
    const [heuredebutDevoir, setheuredebutDevoir] = useState('');
    const [heurefinDevoir, setheurefinDevoir] = useState('');
    const [typeevaluationId, setTypeEvaluation] = useState('');

    // Récupérer la liste des types d'évaluations
    const fetchTypesevaluations = async () => {
        await TypesevaluationsService.index(token)
            .then((response) => {
                setTypesevaluations(response.data.data.typesevaluations);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const fetchDevoir = async () => {
        const id = location.state.id;
        try {
            const response = await DevoirsService.show(id, token);
            if (response.data.status === 200) {
                const devoirData = response.data.data;
                console.log('data:', devoirData);
                // Modifiez cette partie pour inclure le typeevaluationId
                setRowData([{
                    id:devoirData.id,
                    libelleDevoir: devoirData.libelleDevoir,
                    typeevaluationId: devoirData.typesevaluations.id, // Ajoutez cette ligne
                    descriptionDevoir: devoirData.descriptionDevoir,
                    dateDevoir: devoirData.dateDevoir,
                    heuredebutDevoir: devoirData.heuredebutDevoir,
                    heurefinDevoir: devoirData.heurefinDevoir,
                }]);
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.data.message,
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        }
    };

    // Fonction pour ajouter une ligne
    const addRow = () => {
        setRowData([...rowData, {
            libelleDevoir: "",
            typeevaluationId: "",
            descriptionDevoir: "",
            dateDevoir: "",
            heuredebutDevoir: "",
            heurefinDevoir: "",
        }]);
    };

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "numeric", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    // Fonction pour supprimer une ligne
    const removeRow = (index) => {
        const updatedRowData = rowData.filter((_, i) => i !== index);
        setRowData(updatedRowData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        for (let i = 0; i < rowData.length; i++) {
            const row = rowData[i];

            // Mettre à jour les valeurs dans le state si besoin
            const updatedId = row.id;
            
            const updatedlibelleDevoir = row.libelleDevoir;
            setlibelleDevoir(updatedlibelleDevoir);

            const updateddescriptionDevoir = row.descriptionDevoir;
            setdescriptionDevoir(updateddescriptionDevoir);

            const updateddateDevoir = row.dateDevoir;
            setdateDevoir(updateddateDevoir);

            const updatedheuredebutDevoir = row.heuredebutDevoir;
            setheuredebutDevoir(updatedheuredebutDevoir);

            const updatedheurefinDevoir = row.heurefinDevoir;
            setheurefinDevoir(updatedheurefinDevoir);

            const updatedTypeEvaluation = row.typeevaluationId; // Ajouter typeevaluationId
            setTypeEvaluation(updatedTypeEvaluation);

            const formData = new FormData();
            formData.append("id", updatedId);
            formData.append("libelleDevoir", updatedlibelleDevoir);
            formData.append("descriptionDevoir", updateddescriptionDevoir);
            formData.append("dateDevoir", updateddateDevoir);
            formData.append("heuredebutDevoir", updatedheuredebutDevoir);
            formData.append("heurefinDevoir", updatedheurefinDevoir);
            formData.append("typeevaluationId", updatedTypeEvaluation); // Ajouter à formData

            for (let pair of formData.entries()) {
                console.log(`${pair[0]}: ${pair[1]}`);
            }

            try {
                const response = await DevoirsService.update(formData, token);

                if (response.data.status === 200) {

                    // Redirection sur index
                    navigate(myroutes.devoirs_index);
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
            }
        }
    };


    useEffect(() => {
        fetchTypesevaluations();
        fetchDevoir();

    }, []);
    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />
                <div className="row mb-4 mt-3">
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <div className="col-md-12 text-center">
                                <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                                    Programmation de devoirs
                                </h5>
                            </div>
                            <div className="card-body">
                                <Row>
                                    {Object.keys(validationError).length > 0 && (
                                        <div className="alert alert-danger">{validationError}</div>
                                    )}
                                </Row>
                                <Form onSubmit={handleSubmit}>
                                    <Row className="m-3 mb-3">
                                        <div className="col-md-6 ">
                                            <Form.Label>Libelle <i className="text-danger">*</i></Form.Label>
                                            <Form.Control
                                                className="form-control"
                                                type="text"
                                                value={rowData[0].libelleDevoir}
                                                onChange={(e) => {
                                                    const updatedRowData = [...rowData];
                                                    updatedRowData[0].libelleDevoir = e.target.value;
                                                    setRowData(updatedRowData);
                                                }}
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Label>Type d'évaluation <i className="text-danger">*</i></Form.Label>
                                            <Form.Select
                                                className="form-control"
                                                value={rowData[0].typeevaluationId || ""}
                                                onChange={(e) => {
                                                    const updatedRowData = [...rowData];
                                                    // Conversion explicite en nombre
                                                    updatedRowData[0].typeevaluationId = parseInt(e.target.value, 10);
                                                    setRowData(updatedRowData);
                                                }}
                                                required
                                            >
                                                <option value="" disabled>-- Choisir un type --</option>
                                                {typesevaluations.map((item) => (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.libelleTypeEvaluation}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Label>Description <i className="text-danger">*</i></Form.Label>
                                            <Form.Control
                                                className="form-control"
                                                as="textarea"
                                                rows={4}
                                                value={rowData[0].descriptionDevoir}
                                                onChange={(e) => {
                                                    const updatedRowData = [...rowData];
                                                    updatedRowData[0].descriptionDevoir = e.target.value;
                                                    setRowData(updatedRowData);
                                                }}
                                            />
                                        </div>
                                    </Row>
                                    <div className="col-md-12 text-center">
                                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                                            Créer un devoir
                                        </h5>
                                    </div>
                                    <Container>
                                        <Table id="montableau" striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Heure début</th>
                                                    <th>Heure fin</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rowData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <Form.Control
                                                                type="date"
                                                                value={dayjs(row.dateDevoir).format("YYYY-MM-DD")}
                                                                onChange={(e) => {
                                                                    const updatedRowData = [...rowData];
                                                                    updatedRowData[index].dateDevoir = e.target.value;
                                                                    setRowData(updatedRowData);
                                                                }}
                                                                required
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="time"
                                                                value={row.heuredebutDevoir}
                                                                onChange={(e) => {
                                                                    const updatedRowData = [...rowData];
                                                                    updatedRowData[index].heuredebutDevoir = e.target.value + ":00";
                                                                    setRowData(updatedRowData);
                                                                }}
                                                                required
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="time"
                                                                value={row.heurefinDevoir}
                                                                onChange={(e) => {
                                                                    const updatedRowData = [...rowData];
                                                                    updatedRowData[index].heurefinDevoir = e.target.value + ":00";
                                                                    setRowData(updatedRowData);
                                                                }}
                                                                required
                                                            />
                                                        </td>
                                                        <td className="p-2">
                                                            {index === 0 ? (
                                                                <Button id="btnadd" onClick={addRow}>
                                                                    Ajouter
                                                                </Button>
                                                            ) : (
                                                                <Button
                                                                    id="btnsupprimer"
                                                                    variant="danger"
                                                                    onClick={() => removeRow(index)}
                                                                >
                                                                    Supprimer
                                                                </Button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>

                                        <div className="mt-3">
                                            <Button type="submit" className="btn btn-primary">Enregistrer</Button>
                                        </div>
                                    </Container>
                                </Form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}